<div class="container">
    <div>
        <mat-slide-toggle
            [(ngModel)]="zoneCombination.currentState.IsNotCalibrated"
            (change)="onIsNotCalibratedChange($event.checked)">Not to be
            Calibrated</mat-slide-toggle>
        <div *ngIf="zoneCombination.currentState.IsNotCalibrated" class="is-not-calibrater-message-container">
            <div>
                <span class="reasons-label">Reasons</span>
                <mat-form-field class="reasons-select">
                    <mat-select multiple placeholder="Reason" [(value)]="selectedReasons"
                        (selectionChange)="listChanged()">
                        <mat-option class="all" (click)="selectAll()" [value]="null">All Reasons</mat-option>
                        <mat-option *ngFor="let reason of reasons" [value]="reason.Id">
                            {{reason.Reason}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <span *ngIf="!zoneCombination.currentState.IsPlannedDevelopment">{{IS_NOT_CALIBRATED}}</span>
            <span
                *ngIf="zoneCombination.currentState.IsPlannedDevelopment">{{IS_NOT_CALIBRATED_PLANNED_DEVELOPMENT}}</span>
        </div>
    </div>
    <mat-slide-toggle class="planned-development-toggle"
        [(ngModel)]="zoneCombination.currentState.IsPlannedDevelopment">Planned
        Development?</mat-slide-toggle>
</div>
